import React from 'react'

import { NewPassword, useFormsContext } from '@ally/forms'

import { InputWrapper, StyledInputFieldSectionContainer } from '../Shared'

interface CreatePasswordProps {
  title: string
  fieldName: string
  username?: string
  dataTestId?: string
}

export const CreatePassword: React.FC<CreatePasswordProps> = ({
  title,
  fieldName,
  username,
  dataTestId,
}) => {
  // if a username is not passed, look for one entered in the same form
  const {
    values: { username: enteredUsername = '' },
  } = useFormsContext<Record<string, string>>()

  return (
    <StyledInputFieldSectionContainer>
      <InputWrapper>
        <NewPassword
          data-testid={dataTestId}
          label={title}
          name={fieldName}
          username={username || enteredUsername}
        />
      </InputWrapper>
    </StyledInputFieldSectionContainer>
  )
}
